<div class="edit-user-dialog">

  <h2 mat-dialog-title>#{{ user.id }} - {{ user.name }}</h2>

  <mat-dialog-content [formGroup]="form">
    <mat-form-field>
      <mat-label>Email Address</mat-label>
      <input matInput formControlName="emailAddress" value="{{user.emailAddress}}">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>Auth Method</mat-label>
      <input matInput formControlName="authMethod" value="{{user.authMethod}}">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label class="or-label or-label-above">Managing Companies</mat-label>
      <mat-select
        formControlName="managingCompanyIds"
        multiple
        [compareWith]="compareById"
      >
        <mat-select-trigger>
          @if (managingCompaniesList.length > 0) {
            {{ getManagingCompanyLabel() }}
          }
        </mat-select-trigger>

        @for (mc of managingCompaniesList; track mc.id) {
          <mat-option [value]="mc.id">
            <div class="mc-option-row">
              <div class="mc-name">
                {{ mc.companyName }}
              </div>

              <div class="mc-admin">
                <span class="mc-admin-label">Administrator</span>

                <mat-checkbox
                  class="mc-admin-checkbox"
                  [checked]="isManagingCompanyAdmin(mc.id)"
                  [disabled]="!isManagingCompanyMember(mc.id)"
                  (click)="$event.stopPropagation()"
                  (change)="toggleAdmin(mc.id, $event.checked)">
                </mat-checkbox>
              </div>
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>Global Authorities</mat-label>
      <mat-select [id]='"globalAuthorities"' formControlName="globalAuthorities" multiple data-cy="global-authorities-dropdown">
        <mat-option disabled>--- Choose global authority/s ---</mat-option>
        @for (globalAuthority of globalAuthorities; track globalAuthority.value) {
          <mat-option [value]="globalAuthority.value" data-cy="global-authorities-option">
            {{ globalAuthority.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button (click)="close()" data-cy="close-button">Close</button>
    <button mat-raised-button color="primary" (click)="save()" data-cy="save-button">Save</button>
  </mat-dialog-actions>

</div>